export const API = window.location.origin + "/api";

export const COLORS = {
  bg: "#131313", surface: "#1c1b1b", card: "#2a2a2a", border: "#353534",
  accent: "#fd8b00", accentSoft: "#fd8b0020", accentGlow: "#fd8b0040",
  green: "#39FF14", greenSoft: "#39FF1420", blue: "#00daf3", blueSoft: "#00daf320",
  purple: "#9b59b6", purpleSoft: "#9b59b620", teal: "#00c9a7", tealSoft: "#00c9a720",
  text: "#efffe3", textMuted: "#baccb0", textDim: "#85967c",
};

export const ROUTINE_CYCLE = ["Push", "Legs", "Pull", "Descanso"];

export const CYCLE_COLORS = {
  Push: { color: COLORS.purple, icon: "↑", bg: COLORS.purpleSoft },
  Legs: { color: COLORS.green, icon: "⚡", bg: COLORS.greenSoft },
  Pull: { color: COLORS.blue, icon: "↓", bg: COLORS.blueSoft },
  Descanso: { color: "#e8e8e8", icon: "◎", bg: "rgba(232,232,232,0.08)" },
};

export const ROUTINE_DATA = {
  Push: [
    { name: "Press Inclinado (Panatta)", sets: 3, reps: 10, weight: 97.5, rest: 120 },
    { name: "Pek Back (pectoral)", sets: 3, reps: 10, weight: 62.5, rest: 120 },
    { name: "Press Militar (Máquina)", sets: 3, reps: 8, weight: 70, rest: 120 },
    { name: "Elevaciones Laterales (Máq)", sets: 3, reps: 10, weight: 42.5, rest: 120 },
    { name: "Extensión Tríceps Overhead", sets: 3, reps: 10, weight: 35, rest: 120 },
    { name: "Fondos en Paralelas", sets: 3, reps: 12, weight: 0, rest: 120 },
    { name: "Crunch Abdominal (Máq)", sets: 3, reps: 15, weight: 87.5, rest: 120 },
    { name: "Rotación de Torso (Máq)", sets: 3, reps: 10, weight: 55, rest: 120 },
    { name: "Elevaciones de Piernas", sets: 3, reps: 10, weight: 0, rest: 120 },
  ],
  Legs: [
    { name: "Leg Press (Prensa)", sets: 3, reps: 10, weight: 150, rest: 120 },
    { name: "Hip Thrust / Peso Muerto", sets: 3, reps: 10, weight: 45, rest: 120 },
    { name: "Leg Extension", sets: 3, reps: 10, weight: 82.5, rest: 120 },
    { name: "Leg Curl Sentado", sets: 3, reps: 10, weight: 62.5, rest: 120 },
    { name: "Abductor (Erecto)", sets: 3, reps: 10, weight: 102.5, rest: 120 },
    { name: "Abductor (Inclinado 45°)", sets: 3, reps: 10, weight: 102.5, rest: 120 },
    { name: "Aductor (Máquina)", sets: 3, reps: 10, weight: 112.5, rest: 120 },
    { name: "Calf Press (Gemelos)", sets: 3, reps: 10, weight: 92.5, rest: 120 },
    { name: "Descensos de Piernas + Isométrico", sets: 3, reps: 0, weight: 6, rest: 120 },
    { name: "Rueda Abdominal (Wheel Rollout)", sets: 3, reps: 10, weight: 0, rest: 120 },
  ],
  Pull: [
    { name: "Dominadas — Agarre prono", sets: 3, reps: 8, weight: 80, rest: 120 },
    { name: "Dominadas — Agarre supino", sets: 1, reps: 10, weight: 80, rest: 120 },
    { name: "Remo en Máquina — Agarre neutro", sets: 2, reps: 10, weight: 75, rest: 120 },
    { name: "Remo en Máquina — V-bar", sets: 2, reps: 10, weight: 75, rest: 120 },
    { name: "Pek Deck Inverso", sets: 3, reps: 10, weight: 40, rest: 120 },
    { name: "Curl de Bíceps en Polea", sets: 3, reps: 10, weight: 55, rest: 120 },
    { name: "Curl con Mancuernas (martillo)", sets: 3, reps: 10, weight: 15, rest: 120 },
    { name: "Crunch Abdominal (Máq)", sets: 3, reps: 15, weight: 87.5, rest: 120 },
    { name: "Rueda Abdominal (Wheel Rollout)", sets: 3, reps: 10, weight: 0, rest: 120 },
    { name: "Hollow Body Hold", sets: 3, reps: 0, weight: 0, rest: 120 },
  ],
  Descanso: [],
};

// Paleta para días con nombres custom (no Push/Legs/Pull/Descanso)
export const DAY_PALETTE = [
  { color: '#fd8b00', icon: '◈', bg: '#fd8b0020' },  // naranja
  { color: '#39FF14', icon: '⚡', bg: '#39FF1420' },  // verde
  { color: '#00daf3', icon: '↓', bg: '#00daf320' },   // azul
  { color: '#9b59b6', icon: '◎', bg: '#9b59b620' },   // morado
  { color: '#ff6b35', icon: '↑', bg: '#ff6b3520' },   // rojo-naranja
  { color: '#f0c040', icon: '★', bg: '#f0c04020' },   // amarillo
  { color: '#00e5a0', icon: '▲', bg: '#00e5a020' },   // teal
  { color: '#e040fb', icon: '◆', bg: '#e040fb20' },   // rosa
];

// Obtiene color+icono para cualquier nombre de día
export function getDayStyle(dayName) {
  if (CYCLE_COLORS[dayName]) return CYCLE_COLORS[dayName];
  // Hash del nombre → índice consistente
  const idx = [...dayName].reduce((acc, c) => acc + c.charCodeAt(0), 0) % DAY_PALETTE.length;
  return DAY_PALETTE[idx];
}
